<template>
  <div class="item-container">
    <div
      :id="`itemexpander-${item.jsonid}`"
      class="item-main"
      :class="{ 'item-active': dropdown }"
      @click="toggleExpand"
    >
      <div class="item-title">
        <i class="icon-accomodation glyph-lg mr-3" />
        <span>ACCOMMODATION</span>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>{{ item.suppliername }}</h6>
        <p>for {{ item.duration }}</p>
      </div>
      <div class="item-main-desktop">
        <h6>{{ item.city }}</h6>
        <p v-if="fil === 'M'">Check out on {{ item.enddate }}</p>
      </div>
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>
    <div v-if="dropdown" class="item-dropdown">
      <div class="item-dropdown-main">
        <ul>
          <li class="mobile-dropdown-item">
            <h4>Hotel</h4>
            <p>{{ item.suppliername }}</p>
          </li>
          <li class="mobile-dropdown-item">
            <h4>Duration</h4>
            <p>{{ item.duration }}</p>
          </li>
          <li class="mobile-dropdown-item">
            <h4>Hotel in</h4>
            <p>{{ item.city }}</p>
          </li>
          <li
            v-for="expanderItem in item.expanderItems"
            :key="expanderItem.title"
          >
            <h4>{{ expanderItem.title }}</h4>
            <p>{{ expanderItem.notes }}</p>
          </li>
        </ul>
        <div class="extra-info">
          <div v-if="displayImage" class="extra-info-img">
            <img
              class="non-gallery-img"
              :src="addCdnImageWidth(displayImage[0])"
              :alt="displayImage[1]"
            />
            <!-- <span class="extra-info-caption">{{ item.imageurl[1] }}</span> -->
          </div>
          <ExtraInfoButtons itemtype="accomodation" :item="item" />
        </div>
      </div>
      <div
        v-show="returnRateCodeMessage(item.htlratecode) !== ''"
        class="extra-info-notes"
      >
        <div class="rate-alert">
          <i class="material-icons pr-3 text-danger"></i
          >{{ returnRateCodeMessage(item.htlratecode) }}
        </div>
      </div>
      <div v-if="item.offers && item.offers[0]" class="extra-info-notes">
        Trailfinders Special Offers
        <ul>
          <li v-for="(offer, index) in item.offers" :key="index">
            {{ offer }}
          </li>
        </ul>
      </div>
      <div v-if="item.fnotes[0]" class="extra-info-notes">
        Notes
        <ul>
          <li v-for="(note, index) in item.fnotes" :key="index">
            {{ note }}
          </li>
        </ul>
      </div>
      <div v-if="item.requests[0]" class="extra-info-notes">
        <h4>Additional Information</h4>
        <ul>
          <li v-for="(request, index) in item.requests" :key="index">
            {{ request }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ExtraInfoButtons from "@/partials/extra-info-buttons";
import { getLocalTourByCode } from "@/modules/booking/tours/tours.module";
import { addCdnImageWidth } from "@/lib/utilities";

export default {
  components: {
    ExtraInfoButtons,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dropdown: true,
      localToursOpened: false,
      hotelImageFallback: null,
    };
  },
  mounted() {
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
    this.loadFallbackImage();
  },
  computed: {
    mapData() {
      if (this.item && this.item.geocode) {
        const coords = this.item.geocode.split(", ");
        return {
          lat: parseFloat(coords[0]),
          lng: parseFloat(coords[1]),
          zoom: 16,
        };
      }
      return null;
    },
    localTours() {
      const tours = getLocalTourByCode(this.allLocalTours, this.item.citylink);
      if (!tours) {
        return [];
      }
      return tours;
    },
    // The card thumbnail normally comes from the booking feed's `imageurl`.
    // When that's missing, fall back to the hotel feed gallery (same source
    // the info modal uses). Both are flat [url, caption, ...] arrays, so the
    // existing [0]/[1] template bindings work unchanged.
    displayImage() {
      const imageurl = this.item && this.item.imageurl;
      const hasImageUrl = Array.isArray(imageurl)
        ? imageurl.length > 0
        : Boolean(imageurl);
      return hasImageUrl ? imageurl : this.hotelImageFallback;
    },
    ...mapGetters({
      bookingNumber: "booking/getBookingNumber",
      allLocalTours: "tours/getLocalTours",
      fil: "booking/getFil",
      getCountry: "booking/getCountry",
    }),
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
    loadFallbackImage() {
      // Only fetch when the booking feed gave us no image but we do have a
      // hotel page link to look the gallery up with.
      if (this.displayImage || !this.item || !this.item.htlpagelink) {
        return;
      }
      fetch(
        `https://www.trailfinders.com/webdata/hotels/supplierforVT/${this.item.htlpagelink}`
      )
        .then((r) => r.json())
        .then((json) => {
          if (json && json[0]) {
            this.hotelImageFallback =
              json[0].CDNimagemain || json[0].imagemain || null;
          }
        })
        .catch(() => {
          this.hotelImageFallback = null;
        });
    },
    checkHotelOffers(_item) {
      if (_item.offers[0].length >= 1) {
        return true;
      }
    },
    expandAll() {
      this.dropdown = true;
    },
    collapseAll() {
      this.dropdown = false;
    },
    openEssentialInfoModal() {
      this.$refs.EssentialInfoRef.show();
    },
    openVoucher(vouchno) {
      window.open(
        `https://www.trailfinders.com/travel-vouchers/${this.bookingNumber}_${vouchno}.pdf`,
        "_blank"
      );
    },
    toggleLocalTours() {
      this.localToursOpened = !this.localToursOpened;
    },
    returnRateCodeMessage(htlratecode) {
      if (htlratecode === "IP" && this.fil === "M") {
        return "This hotel is 100% non-refundable. No amendments permitted.";
      }

      if (htlratecode === "SD" && this.fil === "P") {
        return "This hotel rate will need to be re-quoted at the time of booking and any change in price applied as it is an instant purchase rate.";
      }
      if (htlratecode === "IP" && this.fil === "P") {
        return "This hotel rate will need to be re-quoted at the time of booking and any change in price applied as it is an instant purchase rate. Once booked, this hotel is 100% non refundable and amendments cannot be made under any circumstance.";
      }
      return "";
    },
    capitalise(text) {
      text = text.toLowerCase();
      let re = /(\b[a-z](?!\s))/g;
      let regexText = text.replace(re, (x) => x.toUpperCase());

      return regexText;
    },
    addCdnImageWidth,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles.scss";
</style>
